import { styled } from "@mui/material/styles"
import { Tooltip, tooltipClasses } from "@mui/material"

export const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
    ({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: "rgb(0, 0, 0)",
            boxShadow: theme.shadows[1],
            padding: 13,
        },
        [`& .${tooltipClasses.arrow}`]: {
            background: "#0000",
            color: theme.palette.primary.main + "A0",
            boxShadow: "none",
            bottom: -3,
            outline: "none",
        },
    })
)
